var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9539 83.0542C85.327 88.5426 80.372 92.4817 74.8837 91.8549L23.2196 85.9539C17.7333 85.3273 13.7921 80.3721 14.419 74.8837L20.3199 23.2196C20.9468 17.7313 25.9038 13.7924 31.3901 14.419L83.0542 20.3199C88.5425 20.9468 92.4817 25.9018 91.8548 31.3901L85.9539 83.0542Z",
    fill: "#673AB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7171 58.3657C69.6298 56.4298 67.9026 54.9845 65.5732 54.0541C65.5732 54.0541 67.684 53.5504 69.8253 51.017C71.1179 49.3932 71.9149 47.3505 72.1963 44.8865C72.6842 40.6143 71.5088 37.1586 68.6654 34.5591C65.822 31.9596 62.4973 30.05 56.5559 29.3714L37.9767 27.2493L32.5297 74.9393L53.2549 77.3065C58.8829 77.909 63.2538 77.1803 66.4006 75.1845C69.5321 73.1467 71.3623 69.8129 71.8956 65.1432C72.1907 62.56 71.8045 60.3016 70.7171 58.3657ZM48.9913 36.5594C48.9913 36.5594 57.2775 37.5058 57.4364 37.524C60.4568 37.869 62.6217 40.5922 62.2768 43.6126C61.9318 46.633 59.2085 48.7979 56.1882 48.4529C56.0292 48.4348 47.7431 47.4884 47.7431 47.4884L48.9913 36.5594ZM55.2954 69.4875L45.36 68.3527L46.7218 56.4302L56.6572 57.565C59.9557 57.9418 62.3143 60.9086 61.9375 64.2071C61.5608 67.5057 58.594 69.8643 55.2954 69.4875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.ddd2a0fc5283aa2591c777845584a346.svg";
export { ForwardRef as ReactComponent };